import React from 'react'

const Section_3 = () => {
    return (
        <div className='js-show-on-scroll xl:px-[8rem] w-[100vw] mt-20 text-[#00263e]'>

            <h1 className='xl:p-0 p-4 text-left text-[36px] font-semibold'>If you want to do business in Thailand, <br></br>you will need an expert partner.</h1>
            <p className=' xl:p-0 p-4 xl:text-ellipsis xl:w-[50%] mt-3 font-semibold'>We know how to navigate the complexities and challenges of the regional regulatory environment to make your Thailand expansion
                compliant & seamless.</p>
            <div className='grid xl:grid-cols-4 lg:grid-cols-2 grid-cols-1'>
                <div className='p-4 mt-3'>
                    <img src="https://thailand.acclime.com/wp-content/uploads/expertise.svg" alt="" className=' h-[72px] w-[72px]' />
                    <h1 className=' text-[24px] mt-2'>Local knowledge</h1>
                    <p className=' text-[16px] font-light mt-2'>Our specialist team has grassroots knowledge and an acute local understanding of the market-specific intricacies and nuances.</p>
                </div>
                <div className='p-4 mt-3'>
                    <img src="https://thailand.acclime.com/wp-content/uploads/attention.svg" alt="" className=' h-[72px] w-[72px]' />
                    <h1 className=' text-[24px] mt-2'>Hands-on attention</h1>
                    <p className=' text-[16px] font-light mt-2'>All of our clients are treated with the same level of importance and get personalized, hands-on attention from our team.</p>
                </div>
                <div className='p-4 mt-3'>
                    <img src="https://thailand.acclime.com/wp-content/uploads/complications.svg" alt="" className=' h-[72px] w-[72px]' />
                    <h1 className=' text-[24px] mt-2'>Speed & flexibility</h1>
                    <p className=' text-[16px] font-light mt-2'>We can make swift and effective decisions on your behalf, cutting through bureaucracy and guiding you forward.</p>
                </div>
                <div className='p-4 mt-3'>
                    <img src="https://thailand.acclime.com/wp-content/uploads/commitment.svg" alt="" className=' h-[72px] w-[72px]' />
                    <h1 className=' text-[24px] mt-2'>Lasting commitment</h1>
                    <p className=' text-[16px] font-light mt-2'>We’re in it for the long run. People who’ll be helping you are owner-managers, with a stake in our firm and a real interest in your success.</p>
                </div>
            </div>
        </div>

    )
}

export default Section_3